import RouteDefaultsCard from '../components/LeftMenu/components/RouteDefaultsCard';
import { RouteListTabs } from '../enums/RouteListTabs';
import CompactCard from '../components/LeftMenu/components/RouteComponents/CompactCard';
import DetailedCard from '../components/LeftMenu/components/RouteComponents/DetailedCard';
import StatsCard from '../components/LeftMenu/components/RouteComponents/StatsCard';
import DetailedSectionDefaultCard from '../components/LeftMenu/components/RouteComponents/DetailedSectionDefaultCard';
import defaultRoutes from '../enums/defaultRoutes';
import SectionOverview from '../components/LeftMenu/components/RouteComponents/SectionOverview';

export const handleTooltipVisibility =
  (tooltipTop, handleTooltipTop) => (data) => {
    const {
      styles,
      popper: { top },
    } = data;
    if (!tooltipTop) {
      handleTooltipTop(top);
    } else if (tooltipTop !== top) {
      return {
        ...data,
        styles: {
          ...styles,
          visibility: 'hidden',
        },
      };
    }

    return data;
  };

export const getCard = (
  type,
  { defaultRoute, sectionRoute, routeCode, sectionCode }
) => {
  if (defaultRoute) {
    if (sectionRoute) {
      return sectionCode ? SectionOverview : DetailedSectionDefaultCard;
    }
    if (defaultRoutes[routeCode]) {
      return RouteDefaultsCard;
    }
  }

  switch (type) {
    case RouteListTabs.compact:
      return CompactCard;
    case RouteListTabs.detailed:
      return DetailedCard;
    case RouteListTabs.stats:
      return StatsCard;
    default:
      break;
  }
};

// card sizes mentioned in pixels
export const getCardSize = (type, defaultRoute) => {
  if (defaultRoute) {
    return 40;
  }

  switch (type) {
    case RouteListTabs.defRoutes:
      return 40;
    case RouteListTabs.compact:
      return 80;
    case RouteListTabs.detailed:
      return 145;
    case RouteListTabs.stats:
      return 194;
    default:
      return 0;
  }
};
